module.exports = __webpack_public_path__ + "img/wt3.460c5757.png";